














import Vue from 'vue'
export default Vue.extend({
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false
    },
    url: {
      type: String,
      required: false
    },
    imgUrl: {
      type: String,
      required: false
    },
    imgPositionTop: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    imageUrl () {
      return 'background-image: url(' + this.imgUrl + ');'
    }
  }
})
